export default __webpack_public_path__ + "static/media/Drawing Card Swish.f4df9f4a.mp3";